import { render, staticRenderFns } from "./User_PAW_offer.vue?vue&type=template&id=0c6e6871&scoped=true&"
import script from "./User_PAW_offer.vue?vue&type=script&lang=js&"
export * from "./User_PAW_offer.vue?vue&type=script&lang=js&"
import style0 from "./User_PAW_offer.vue?vue&type=style&index=0&id=0c6e6871&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e6871",
  null
  
)

export default component.exports